import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { BrandCampaignService } from "../../brand/brand-campaign/shared/services/brand-campaign.service";
import { BrandCampaignUrl, BrandUrl } from "../../brand/brand.url";

export type CampaignUrlGetter = (brandId: number, campaignId: number) => string;

export function BetaCampaignGuard(): CanActivateFn {
  const BetaCampaignSectionsURLs = [
    BrandUrl.Campaign.Partners,
    BrandUrl.Campaign.DetailsSettings,
    BrandUrl.Campaign.DetailsInfo,
    BrandUrl.Campaign.DetailsInvitePage,
    BrandUrl.Campaign.Publications,
    BrandUrl.Campaign.LandingPage,
    BrandUrl.Campaign.InvitePartners,
    BrandUrl.Campaign.Summary,
  ];

  const getCampaignUrlPattern = (urlGetter: CampaignUrlGetter): string => {
    const fakeFullUrl = urlGetter(0, 0);
    const brandCampaignUrl = BrandCampaignUrl(0, 0);
    return fakeFullUrl.replace(brandCampaignUrl, "");
  };

  return async (route, state): Promise<boolean> => {
    const router = inject(Router);
    const brandCampaignService = inject(BrandCampaignService);

    const campaign = brandCampaignService.currentBrandCampaign;

    if (!campaign.isBeta) {
      return true;
    }

    if (
      BetaCampaignSectionsURLs.some((getter) =>
        state.url.includes(getCampaignUrlPattern(getter)),
      )
    ) {
      return true;
    }

    const brandId = Number(route.paramMap.get("brandId"));
    await router.navigate([
      BrandUrl.Campaign.DetailsSettings(brandId, campaign.id),
    ]);
    return false;
  };
}
